<template>
  <div>
    <JetDialogModal
      :show="modalOpen"
      ref="modal"
      @close="modalClose"
      v-if="modalOpen"
    >
      <template #title>
        <h2>Add Link</h2>
      </template>
      <template #content>
        <form @submit.prevent="handleSubmit()" method="POST">
          <div class="py-2">
            <label
              class="w-full block text-gray-700"
            >URL</label>
            <jet-input
              v-model="url"
              type="url"
              ref="inputUrl"
              placeholder="https://example.com"
              class="mb-3 w-full"
            />
            <span class="block text-sm mt-2 leading-none text-gray-700">
              Your link will be replaced with a shortened URL that will redirect recipients to the original URL you entered.
              This will generate a unique link for each recipient so you can track which contacts clicked this link.
            </span>
            <ul v-if="errors.length">
              <li v-for="error in errors" class="text-sm text-red-600">{{ error }}</li>
            </ul>
          </div>
        </form>
      </template>

      <template #footer>
        <button class="mr-4" @click="modalClose">
          Cancel
        </button>

        <JetSecondaryButton
          class="px-2 py-1 text-xs"
          type="button"
          @click="handleSubmit"
        >Add Link</JetSecondaryButton>
      </template>
    </JetDialogModal>
    <custom-tooltip
      v-if="messageHasLink && showTooltip"
      @tooltipVisibility="tooltipVisibility($event)"
      :message="`It looks like you are sending a link. \n Shorten it and track link clicks here.`">
    </custom-tooltip>
    <button
      class="text-xs sm:text-sm cursor-pointer px-4 py-2 bg-gray-100 rounded-full hover:bg-gray-300 focus:outline-none"
      :class="[messageHasLink  && showTooltip ? 'bg-gray-300': '']"
      type="button"
      @click.prevent="modalOpen = true"
    ><font-awesome-icon :icon="['far', 'link']" /> Add Link</button>
  </div>
</template>
<script>
import JetDialogModal from "../Jetstream/DialogModal";
import JetSecondaryButton from "../Jetstream/SecondaryButton";
import JetInput from "../Jetstream/Input";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLink } from '@fortawesome/pro-regular-svg-icons';
import CustomTooltip from '../components/CustomTooltip.vue';
library.add(faLink);

export default {
    emits: ['update:modelValue'],
  components: {
    JetDialogModal,
    JetSecondaryButton,
    JetInput,
    CustomTooltip
  },
  props: {
    messageHasLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      errors: [],
      modalOpen: false,
      url: null,
      showTooltip: true
    }
  },
  computed: {
    fieldValue() {
      if (!this.url) return '';

      return `{ link url="${encodeURI(this.url)}"}`;
    },
  },
  methods: {
    handleSubmit() {
      this.errors = [];

      const inputIsValid = this.$refs.inputUrl.$el.checkValidity();
      if ( !inputIsValid ) {
        this.errors.push('Please input a valid URL (including https://)');
        return;
      }
      //the check validity sometimes can not be accurate, make sure the value actually starts with http:// or https://
        if (!this.url.startsWith('http://') && !this.url.startsWith('https://')) {
            this.errors.push('Please input a valid URL (including https://)');
            return;
        }

        console.log("Emitting modelValue", this.fieldValue);
      this.$emit('input', this.fieldValue);

      this.$nextTick(() => {
        this.modalClose();
        this.reset();
      });
    },
    reset() {
      this.url = null;
      this.errors = [];
    },
    modalClose() {
      this.modalOpen = false;
    },
    tooltipVisibility(status) {
      this.showTooltip = status
    }
  }
}
</script>
